import { render, staticRenderFns } from "./single_mul_header.vue?vue&type=template&id=2a180f6e&scoped=true"
import script from "./single_mul_header.vue?vue&type=script&lang=ts"
export * from "./single_mul_header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a180f6e",
  null
  
)

export default component.exports